import { lazy, Suspense, useMemo, useState } from 'react';
import { Modal } from 'rsuite';
import { IoMapOutline } from 'react-icons/io5';
import { MAP_PIN } from '../../utils/constants/images';
import BestStartButton from '../button';
import Loader from '../loader';
import './address-map-button.css';

const MapView = lazy(() => import('../map-view'));


function toNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function getPosition(item) {
  return { longitude: item.longitude, latitude: item.latitude };
}

function getId(item) {
  return item.id;
}

export default function AddressMapButton({ address, title = 'Location', width = 120, height = 38, iconOnly = false, zIndex, 'data-testid': dataTestId = 'address-map-button' }) {
  const [open, setOpen] = useState(false);

  const latitude = toNumber(address?.latitude);
  const longitude = toNumber(address?.longitude);
  const hasCoords = latitude != null && longitude != null;

  const label = useMemo(() => {
    const parts = [address?.address1, address?.address2, address?.address3, address?.city].filter(Boolean);
    return parts.join(', ') || title;
  }, [address, title]);

  const items = useMemo(() => {
    if (!hasCoords) return [];
    return [{ id: 'selected', latitude, longitude, label }];
  }, [hasCoords, latitude, longitude, label]);

  const renderPopup = (item) => (
    <div className="map-view-popup-card">
      <h4 className="map-view-popup-title">{title}</h4>
      {item.label && item.label !== title && <p className="map-view-popup-meta">{item.label}</p>}
    </div>
  );

  return (
    <>
      <BestStartButton
        content={<><IoMapOutline aria-hidden="true" />{!iconOnly && ' Map'}</>}
        color="green"
        width={width}
        height={height}
        appearance="primary"
        onClick={() => setOpen(true)}
        aria-label={`View ${title} on map`}
        title={hasCoords ? `View ${title} on map` : 'No coordinates set for this address'}
        data-testid={dataTestId}
      />
      <Modal size="lg" open={open} onClose={() => setOpen(false)} style={zIndex != null ? { zIndex } : undefined}>
        <Modal.Header className="modal-header">
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, overflow: 'hidden' }}>
          <div className="address-map-modal-map">
            <Suspense fallback={<Loader content="Loading map..." />}>
              <MapView
                items={items}
                getId={getId}
                getPosition={getPosition}
                markerIcon={MAP_PIN}
                renderPopup={renderPopup}
                initialViewState={hasCoords ? { longitude, latitude, zoom: 18 } : undefined}
                singlePointZoom={18}
                ariaLabel={`${title} location map`}
                emptyMessage="No coordinates available for this address."
                minHeight={480}
              />
            </Suspense>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
